const imageBaseurl = '';
const imageUrls = {
  logo: imageBaseurl + '/health/images/new_logo.jpg',
  sihnup: imageBaseurl + '/health/images/doctor2.png',
  signin: imageBaseurl + '/health/images/new_doctor.jpg',
  facilities: imageBaseurl + '/health/images/facilities.svg',
};
export { imageUrls };
